//Highlight project

var $ = require('jquery');
global.jQuery = require("jquery");


$(function () {

    //Function for triggering the third level navigation
    function toggleThirdLevelNav () { 
        $(".toggle-nav").on('click', function () {
            $(".nav-title span, .nav-title h1").toggleClass('open');

            if ($(".nav-links").hasClass('show')) {
                $(".nav-links").removeClass('show');
            } else {
                $(".nav-links").addClass('show');
            }
               
        });
    }

    toggleThirdLevelNav(); //call on document ready

    $('.pie').each(function (index, element) {
        var num = +($(this).text());
        var chart = '<svg viewBox="0 0 32 32"><circle class="circle" r="16" cx="16" cy="16" style="stroke-dasharray: 10 100" /><circle class="middle" r="9" cx="16" cy="16" /></svg>';
        $(this).html(chart);
        $(this).find('.circle').css('stroke-dasharray', num + ' 100');
        $(this).append('<span>' + num + '%</span>');
    });

    var $window = $(window);
    var $elem = $(".pie")

    function isScrolledIntoView($elem, $window) {
        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();

        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }


    if ($(".stats--animated").length) {
        $(document).on("scroll", function () {
            if (isScrolledIntoView($elem, $window)) {
                $elem.addClass("animate");
            }
        });
    }
});